export default __webpack_public_path__ + "static/3-a9a6dd31e6af0402fc49bab8878a85f0.png";